(function()  {

    'use strict';

    const Library = function (element) {

        // The library object itself
        this.element = element;

        this.filter = element.getElementsByTagName('SELECT')[0];

        this.changeLanguage = this.changeLanguage.bind(this);

        this.initiateListener();
    }

    /**
     * Starts listening
     */
    Library.prototype.initiateListener = function () {
        this.filter.addEventListener('change', this.changeLanguage);
    }

    /**
     * Change language
     */
    Library.prototype.changeLanguage = function (event) {

        const url = new URL(window.location.href);
        url.searchParams.set('language', event.target.value);

        window.location.href = url.toString();
    }

    const libraries = document.getElementsByClassName('js-library');

    for (const library of libraries) {
        new Library(library);
    }

}());